import { z } from "zod";

// The **browser↔BFF** schemas for the signed-in Print Specification dialog
// (#1025) — the other seam from #1021's declarations in
// `@/server/data/internal-api/pdf-exports` (`client/docs/architecture.md` L2,
// "Two seams, two homes for a schema"). The share visitor's print takes the
// same document and job id plus the token (`./share-public`).
//
// The modes and statuses are retyped here because this
// client-importable file cannot reach the server-only wire module; a unit test
// holds them to #1021's.

/** The two documents: Detailed and Condensed. */
export const PDF_EXPORT_MODES = ["detailed", "condensed"] as const;
export type PdfExportMode = (typeof PDF_EXPORT_MODES)[number];

/** Where a print is: `queued → rendering → done | failed`. */
export const PDF_EXPORT_STATUSES = ["queued", "rendering", "done", "failed"] as const;
export type PdfExportStatus = (typeof PDF_EXPORT_STATUSES)[number];

const recordId = z.number().int().min(1);

/** Queue a print of one version in one mode. */
export const createPdfExportInputSchema = z.strictObject({
  specificationId: recordId,
  versionId: recordId,
  mode: z.enum(PDF_EXPORT_MODES),
});

export type CreatePdfExportInput = z.infer<typeof createPdfExportInputSchema>;

/** A print's status or bytes, by the job id its create answered. */
export const pdfExportJobInputSchema = z.strictObject({
  jobId: z.uuid(),
});

export type PdfExportJobInput = z.infer<typeof pdfExportJobInputSchema>;
